/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["p[_ngcontent-%COMP%]{color:gray}.hero[_ngcontent-%COMP%]{position:relative;width:100%;background-color:#2638c4;margin-bottom:30px}.container[_ngcontent-%COMP%]   app-localization[_ngcontent-%COMP%]     .localization-wrapper .localization .row .call-to-action-wrapper{margin:0 20px 15px}"];
export { styles as styles };
